import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'formatText'
})
export class FormatTextPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return '';

    // First, escape HTML entities to prevent XSS but preserve newlines
    const escaped = value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;');
    
    // Split by double newlines first to create paragraphs
    const paragraphs = escaped.split(/\n\n+/);
    
    // Process each paragraph - replace single newlines with <br> tags
    const processedParagraphs = paragraphs.map(p => {
      return `<p>${p.replace(/\n/g, '<br>')}</p>`;
    });

    // Join all paragraphs and safely render HTML
    const formattedText = processedParagraphs.join('');
    return this.sanitizer.bypassSecurityTrustHtml(formattedText);
  }
}


// WEBPACK FOOTER //
// ./src/app/pipes/format-text.pipe.ts